import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { CaseService } from 'src/app/services/case.service';

@Component({
  selector: 'app-new-case',
  templateUrl: './new-case.component.html',
  styleUrls: ['./new-case.component.css'],
})
export class NewCaseComponent implements OnInit {
  activeStep = 0;
  caseSteps = [
    {
      name: 'Client Information',
      key: 'client_information',
      isCompleted: false,
      checked: false,
    },
    {
      name: 'Location Details',
      key: 'location_details',
      isCompleted: false,
    },
    {
      name: 'Subject Details',
      key: 'subject_details',
      isCompleted: false,
    },
    // {
    //   name: 'Case Details',
    //   key: 'case_details',
    //   isCompleted: false,
    // },
    {
      name: 'Preview',
      key: 'preview',
      isCompleted: false,
    },

  ];
  caseData$: Observable<any>;
  activeLocation: any;
  editLocationIndex: number;
  activeSubject = null;
  editSubjectIndex: number;

  constructor(
    private caseService: CaseService,
  ) {}

  ngOnInit() {
    this.caseService.setCaseData(null);
    this.caseData$ = this.caseService.getCaseData();
  }

  handleStepFormSubmit(stepper: string,step: number = null) {
    if (step !== null) {
      this.activeStep = step;
    }
    this.caseSteps.find(s => s.key == stepper).checked = true;
  }

  goBack(step: number) {
    this.activeStep = step;
    if(step == 1){
      this.activeLocation = null;
      this.editLocationIndex = null;
    }
  }

  prefillLocation(location,index: number) {
    this.activeStep = 1;
    this.activeLocation = null;
    this.editLocationIndex = null;
    setTimeout(() => {
      this.editLocationIndex = index;
      this.activeLocation = {...location};
    }, 100);
  }

  prefillSubject(subject, index: number) {
    this.activeStep = 2;
    this.activeSubject = null;
    this.editSubjectIndex = null;
    setTimeout(() => {
      this.editSubjectIndex = index;
      this.activeSubject = {...subject};
    }, 100);
  }
}
